module.exports = __webpack_public_path__ + "img/YR25-0500-3-complete.1c9ca9b1.png";